import React from 'react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="section-title">Get in Touch</h2>
          <div className="section-divider"></div>
          <p style={{ fontSize: '1.125rem', maxWidth: '32rem', margin: '0 auto', color: 'inherit' }}>
            Have questions about our apps or want to share feedback? 
            We'd love to hear from you.
          </p>
        </div>

        <div style={{ maxWidth: '48rem', margin: '0 auto' }}>
          <div className="card">
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem', color: 'inherit' }}>
              Contact Information
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div className="contact-info">
                <div className="contact-icon">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="contact-label">Email</p>
                  <a href="mailto:info@rapidnova.co" className="contact-email">
                    info@rapidnova.co
                  </a>
                </div>
              </div>

              <div className="contact-info">
                <div className="contact-icon">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="contact-label">Address</p>
                  <p className="contact-value">
                    60 Paya Lebar Road, #07-54<br />
                    Paya Lebar Square<br />
                    Singapore 409051
                  </p>
                </div>
              </div>

              <div className="contact-info">
                <div className="contact-icon">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="contact-label">Focus</p>
                  <p className="contact-value">Mobile App Development</p>
                </div>
              </div>

              <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                <a
                  href="mailto:info@rapidnova.co?subject=General%20Inquiry&body=Hello%20RapidNova%20team,%0A%0AI%20have%20a%20question%20about%20your%20apps.%0A%0AThank%20you!"
                  className="btn-primary"
                >
                  <svg style={{ width: '20px', height: '20px', marginRight: '8px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Send us an Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 